module.exports = __webpack_public_path__ + "img/hardware.646fccaa.jpg";